module.exports = __webpack_public_path__ + "img/EE.dd2a64a6.svg";